import {
  GET_PROFILE,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_FAILURE,
} from 'store/AdminProfile/AdminProfileAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const profileDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROFILE:
      return { ...state, loading: true };
    case GET_PROFILE_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_PROFILE_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default profileDataReducer;
